import React from 'react';

import './style.css';

type CardFooterProps = {
  children: React.ReactChild,
  childClassName: string,
}

const CardFooter = ({
  children,
  childClassName,
}: CardFooterProps): JSX.Element => (
  <div className={childClassName}>
    {children}
  </div>
);

export default CardFooter;
